// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ArticleVariantModel from '../../model/article-variant-model';
import ArticleVariantDTO from '../dto/article-variant-dto';
import dtoSchema from '../schemas/article-variant-schema';
import ArticleModel from '../../model/article-model';

export default abstract class ArticleVariantModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ArticleVariantDTO>) {
    super();
    if (data) {
      this.title = data.title ?? undefined;
      this.article = data.article ? ArticleModel.toModel(data.article) : undefined;
    }
  }
  /**
  */
  title?: string;
  /**
  */
  article?: ArticleModel;

  static toModel(dto: DeepPartial<ArticleVariantDTO>): ArticleVariantModel;
  static toModel(dto: DeepPartial<ArticleVariantDTO> | undefined | null): ArticleVariantModel | undefined;
  static toModel(dto: DeepPartial<ArticleVariantDTO> | undefined | null): ArticleVariantModel | undefined {
    return dto ? new ArticleVariantModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ArticleVariantModel> | ArticleVariantModel): ArticleVariantDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      title: unwrapped.title,
      article: unwrapped.article,
    } as ArticleVariantDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ArticleVariantModel, can not map to ArticleVariantDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
